<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="handleBack">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                </div>

                <div class="card-container">
                    <div class="card-wrapper">
                        <div class="card-header">
                            中级管理会计计划统计报表
                        </div>
                        <div class="card-date">时间：2021-11-26  08:50:00</div>
                        <div class="card-content">
                                扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...
                            扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...
                            扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...
                            扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，对课程有任何疑问的都可以私聊我。家家
                        </div>
                        <div class="card-download-wrapper">
                            <div class="card-download-title">附件下载：</div>
                            <div class="card-download-file">
                                <div class="card-download-file-item">
                                    银行管肺炎疫情不可抗力处.docx
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
export default {
    name: '',
    components:{
      Header
    },
    data() {
        return {
            
        }
    },
    mounted(){
        
    },
    methods: {
        handleBack(){
            this.$router.push('/myRights/offline-course/detail');
        }
    }
}
</script>

<style scoped>
.page-container {
  width: 100%;
  margin: 0 auto;
}
.page-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 100px;
}
.page-back-wrapper {
  width: 100%;
  height: 68px;
  background: #ffffff;
  box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
  border-radius: 8px;
  border: 1px solid #f0f0f3;
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.page-back-img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: inline-block;
  position: relative;
  top: 2px;
}
.page-back {
  display: flex;
  align-items: center;
  margin-left: 30px;
  cursor: pointer;
}
.card-container{
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EAEAEA;
    display:flex;
    margin-top:18px;
    position: relative;
    min-height:600px;
}
.card-wrapper{
    flex:1;
    margin:30px 45px 53px 45px;
}
.card-header{
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align:center;
}
.card-date{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    margin-top:18px;
    text-align:center;
}
.card-content{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
    letter-spacing: 1px;
    margin-top:32px;
}
.card-download-wrapper{
    margin-top:30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
}
.card-download-file-item:hover{
    cursor:pointer;
    color:#3E63EE;
}
</style>


